<template>
  <div class="container-fluid h-100">
    <div class="row h-100 align-items-center justify-content-center" style="flex-direction: column;">
      <div class="big font-weight-bold" style="font-size: 10em; color: #FF8181;">
        Blacklisted
      </div>
      <div class="col-md-4  text-center">
        <div class="h4 text-muted">You Have been Blacklisted</div>
        <p class="text-muted mb-3">You can no longer access this site. Your tutor ID has been blacklisted</p>
        <div class="text-center">
          <button @click="doNothing" class="btn btn-rounded btn-success">Appeal</button>
          <button @click="logout" class="btn btn-rounded btn-success">Logout</button>
        </div>
        <div class="mt-5 row justify-content-center">
          <div class="col-12 col-md-8 social" style="font-size: 1.3em;">
            <div class="d-flex justify-content-around">
              <a class="footer-link " href="https://facebook.com/prepclass.com.ng">
                <i class="fab fa-facebook-square"></i>
              </a>
              <a class="footer-link " href="https://twitter.com/PrepclassNG">
                <i class="fab fa-twitter-square"></i>
              </a>
              <a class="footer-link " href="http://gplus.to/prepclass">
                <i class="fab fa-google-plus-square"></i>
              </a>
              <a class="footer-link " href="https://www.instagram.com/prepclassng/">
                <i class="fab fa-instagram"></i>
              </a>
              <a class="footer-link " href="https://youtube.com/prepclassng">
                <i class="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="chat container" v-show="a">
        <div class="comments row mb-0">
          <div class="comment">
            <div class="from-admin">
              <div class="box">Hi, how can I help you?</div>
              <div class="time">10:24 <span>Ella</span></div>
            </div>
          </div>
          <div class="comment" v-for="comment of p">
            <div :class="commentType(comment.creator && comment.creator.type)">
              <div class="box">{{comment.comment }}</div>
              <div class="time">{{ moments(comment.updated_at && comment.updated_at.date) }} <span v-if="comment.creator && comment.creator.type === 'user'">{{ comment.creator && comment.creator.name }}</span></div>
            </div>
          </div>
        </div>
        <div class="compose row">
          <textarea v-model="text" @keyup.enter.prevent="send" :disabled="submitting"></textarea>
          <span class="button" @click.prevent="send" :disabled="submitting"><i class="zmdi zmdi-long-arrow-right"></i><i class="fa fa-spin fa-circle-o-notch" v-show="submitting"></i></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';

export default {
  name: 'blacklisted',
  data() {
    return {
      a: false,
      text: '',
      submitting: false,
    };
  },
  computed: {
    p() {
      return this.$store.getters.appeal_conversation;
    },
  },
  methods: {
    moments(val) {
      return moment(val).format('MMM D, YYYY');
    },
    doNothing() {
      this.a = true;
    },
    send() {
      if (this.text !== '') {
        this.submitting = true;

        this.$store.dispatch('addAppealComment', this.text )
          .then((response) => {
            this.submitting = false;
            this.text = '';
          })
          .catch((error) => {
            if (typeof error !== 'undefined') {
              swal(error.status, error.message, 'error');
            }
            this.submitting = false;
          });
      }
    },
    commentType(val) {
      switch (val) {
        case 'user':
          return 'from-admin';

        default:
          return 'to-admin';
      }
    },
    logout() {
      this.$auth.logout({
        makeRequest: false,
        success: () => {
          this.$router.push({name: 'login'}).catch(err => {});
        },
        error() {
          console.log('error logging out ');
        },
      });
    },
  },
  mounted() {
    this.$store.dispatch('getAppealConversation', this.id)
      .then(() => {
      })
      .catch(error => console.error(error));
  },
  updated() {
    const comments = this.$el.querySelector('.comments');
    comments.scrollTop = comments.scrollHeight;
  },
};
</script>

<style lang="scss" scoped>
.social a {
  color: #888;
  font-size: 1.5em;
}
.chat {
    width: 100%;
    padding: 15px 0;
    margin: 10px 0;

    .comments {
      width: 100%;
      padding: 25px 10px;
      height: 400px;
      max-height: 400px;
      overflow-y: auto;
      border: 1px solid rgba(100, 100, 100, 0.1);

      .comment {
        width: 100%;
        height: auto;
        overflow: hidden;
        display: block;

        .from-admin {
          width: auto;
          max-width: 35%;
          float: left;

          .box {
            padding: 10px 15px;
            background-color: #edf0f5;
            color: #60626e;
            border-radius: 20px;
            border-bottom-left-radius: 0;
            font-size: 14px;
          }
          .time {
            color: #60626e;
            font-size: 12px;
            padding: 5px;
            span {float: right; font-weight: bold;}
          }
        }
        .to-admin {
          width: auto;
          max-width: 35%;
          float: right;

          .box {
            padding: 10px 15px;
            background-color: #dde8d5;
            color: #60626e;
            border-radius: 20px;
            border-bottom-right-radius: 0;
            font-size: 14px;
          }
          .time {
            color: #60626e;
            font-size: 12px;
            padding: 5px;
            text-align: right;
            span {float: right; font-weight: bold;}
          }
        }
      }
    }
    .compose {
      border: 1px solid rgba(100, 100, 100, 0.1);
      padding: 0;
      width: 100%;
      position: relative;
      textarea {
        width: 100%;
        max-height: 250px;
        border: none;
        padding: 8px;
        padding-right: 25px;
        font-size: 13px;
        background-color: rgba(200, 200, 200, 0.1);
        color: #333;
        border-radius: 4px;
        &:focus {outline: none;}
      }
      span.button {
        position: absolute;
        right: 10px;
        top: 50%;
        color: #007bff;
        font-size: 16px;
        cursor: pointer;
        text-transform: uppercase;
        transform: translateY(-50%);
        &:hover {
          color: #385898;
        }
      }
    }
  }
</style>

 


// WEBPACK FOOTER //
// src/components/BlackListed.vue